import { combineReducers } from 'redux';
import * as R from 'ramda';
import {
  SOCIAL_RECEIVE_FEED,
  SOCIAL_RECEIVE_SCHEDULED_MESSAGES,
  SOCIAL_DELETE_MESSAGE,
  SOCIAL_POST_MESSAGE,
  SOCIAL_EDIT_MESSAGE,
} from '../actions';

function getMessageId(action) {
  return action.messageId
    || action.message?.source?.id
    || action.message?.source_id
    || action.message?.id;
}

function getIsStillScheduled(message) {
  return !!(message?.publish_at ?? message?.source?.publish_at);
}

const items = (state = [], action) => {
  switch (action.type) {
    case SOCIAL_RECEIVE_SCHEDULED_MESSAGES:
      return action.append
        ? [...state, ...R.pluck('source_id', action.items)]
        : R.pluck('source_id', action.items);
    case SOCIAL_DELETE_MESSAGE:
      return R.reject(R.equals(action.messageId), state);
    case SOCIAL_POST_MESSAGE:
      if (!action.scheduled) return state;

      return R.uniq([...state, getMessageId(action)]);
    case SOCIAL_EDIT_MESSAGE: {
      const messageId = getMessageId(action);
      if (!messageId) return state;

      const isStillScheduled = action.isStillScheduled ?? getIsStillScheduled(action.message);
      const wasScheduled = action.scheduled;

      if (wasScheduled && !isStillScheduled) {
        return R.reject(R.equals(messageId), state);
      }

      if (isStillScheduled && !state.includes(messageId)) {
        return [...state, messageId];
      }

      return state;
    }
    default: return state;
  }
};

const count = (state = 0, action) => {
  switch (action.type) {
    case SOCIAL_RECEIVE_FEED:
      return action.scheduledCount || 0;
    case SOCIAL_DELETE_MESSAGE:
      if (!action.scheduled || state === 0) return state;

      return state - 1;
    case SOCIAL_POST_MESSAGE:
      if (!action.scheduled) return state;

      return state + 1;
    case SOCIAL_EDIT_MESSAGE: {
      const isStillScheduled = action.isStillScheduled ?? getIsStillScheduled(action.message);
      const wasScheduled = action.scheduled;

      if (wasScheduled && !isStillScheduled) {
        return Math.max(state - 1, 0);
      }

      if (!wasScheduled && isStillScheduled) {
        return state + 1;
      }

      return state;
    }
    default: return state;
  }
};

export default combineReducers({ items, count });
